export default __webpack_public_path__ + "static/media/colagio-logo-warna-tulisan-putih.413feeec.png";